import React, { useState } from "react";
import "../../css/CRUDModal.css";
import ButtonTriangle from "../../assets/Icons/bthTriangle.svg";
import { useForm, Controller } from "react-hook-form";
import { Box, CircularProgress } from "@mui/material";
import CustomAlert from "../../helpers/CustomAlert";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import LeftCircle from "../../assets/Icons/Left Circle.svg";
import RightCircle from "../../assets/Icons/Right Circle.svg";
import FilterIcon from "../../assets/Icons/filter icon.svg";
import CrossIcon from "../../assets/Icons/cross_svg.svg";

const serviceType = [
  { value: "BUY_SMS", label: "Buy SMS" },
  { value: "BUY_RCS", label: "Buy RCS" },
  { value: "TOPUP_SMS", label: "Top up SMS" },
  { value: "TOPUP_RCS", label: "Top up RCS" },
];

const VendorHistoryFilterModal = ({
  show,
  handleClose,
  setFilterData,
  filterData,
  handleReset,
  setSellSMSData,
  setPageDetails,
  setNoData,
  pageSize,
  currentPage,
}) => {
  const {
    control,
    handleSubmit,
    setValue,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({
    defaultValues: {
      vendorName: filterData.vendorName || "",
      vendorId: filterData.vendorId || "",
      txnsType: filterData.txnsType || "",
      status: filterData.status || [],
      fromDate: filterData.fromDate || "",
      toDate: filterData.toDate || "",
    },
    mode: "onChange",
  });

  const [selectedTab, setSelectedTab] = useState("Vendor Name");
  const [loading, setLoading] = useState(false);
  const loggedInUserName = sessionStorage.getItem("username");

  const handleTabChange = (e, tabName) => {
    e.preventDefault();
    setSelectedTab(tabName);
  };

  const getTodayDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, "0");
    const day = String(today.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const onSubmit = (data) => {
    setFilterData(data);
    fetchSellSMSData(data, currentPage);
    handleClose();
  };

  const fetchSellSMSData = async (data, pageNo) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        vendorName: data.vendorName,
        vendorId: data.vendorId,
        txnsType: data.txnsType,
        status: data.status || [],
        fromDate: formatDate(data.fromDate),
        toDate: formatDate(data.toDate),
      };

      const response = await axiosPostApi(
        `${apiList.FETCH_SELLSMS_DATA}?&pageSize=${pageSize}&pageNo=${pageNo}`,
        requestBody
      );

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setPageDetails(response?.data?.pageDetails);
        const transactions = response?.data?.data;
        const modifiedData = modifyStructure(transactions);
        setSellSMSData(modifiedData);

        if (modifiedData?.length === 0) {
          setNoData(true);
          CustomAlert({
            title: "Failed",
            text: "No transactions matched the selected filters.",
            icon: "error",
            confirmButtonText: "OK",
          });
        } else {
          setNoData(false);
        }
      } else {
        setNoData(true);
        setSellSMSData([]);
        CustomAlert({
          title: "Failed",
          text: "No transactions matched the selected filters.",
          icon: "error",
          confirmButtonText: "OK",
        });
        if (
          response?.data?.respCode !== "01" &&
          response?.data?.data !== null
        ) {
          CustomAlert({
            title: "Failed to Fetch Data",
            text:
              response?.data?.message ||
              "No data available for the specified criteria.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
    } finally {
      setLoading(false);
    }
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      transactionDate: item.transactionDate?.split(" ")?.[0],
      id: index + 1,
    }));
  };

  const onReset = () => {
    reset({
      vendorName: "",
      vendorId: "",
      txnsType: "",
      status: [],
      fromDate: "",
      toDate: "",
    });
    setFilterData({
      vendorName: "",
      vendorId: "",
      txnsType: "",
      status: [],
      fromDate: "",
      toDate: "",
    });
    handleReset();
  };

  return (
    <>
      {show && (
        <div
          style={{
            position: "fixed",
            top: 0,
            right: 0,
            bottom: 0,
            left: 0,
            backgroundColor: "rgba(0,0,0,0.4)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 1060,
          }}
        >
          <div className="modal-dialog" role="document">
            <div
              className="modal-content"
              style={{
                width: "40vw",
                borderRadius: "24px",
                padding: "24px",
                backgroundColor: "#FFF",
                border: "1px solid rgba(0, 0, 0, 0.175)",
              }}
            >
              <img
                src={LeftCircle}
                alt="leftImg"
                className="absolute left-0 bottom-0 w-[110px] h-[105px]"
              />
              <img
                src={RightCircle}
                alt="leftImg"
                className="absolute right-0 top-0 w-[110px] h-[105px]"
              />
              <div
                className="modal-header"
                style={{
                  padding: "1rem 1rem",
                  borderBottom: "1px solid #dee2e6",
                  justifyContent: "space-between",
                  display: "flex",
                }}
              >
                <div className="flex items-center gap-2">
                  <img src={FilterIcon} alt="filter icon" className="w-6 h-6" />
                  <h5 className="modal-title main-title font-medium">
                    Filters
                  </h5>
                </div>
                <img
                  src={CrossIcon}
                  alt="filter icon"
                  className="w-[30px] h-[30px] cursor-pointer z-20"
                  onClick={handleClose}
                />
              </div>
              <Box component="form" onSubmit={handleSubmit(onSubmit)}>
                <div
                  className="scoped-modal modal-body"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    width: "100%",
                  }}
                >
                  <div className="tab-container">
                    <ul className="tab-list">
                      {[
                        "Vendor Name",
                        "Vendor Id",
                        "Transaction Type",
                        "Status",
                        "Transaction Date",
                      ].map((tab) => (
                        <div className="tab-wrapper" key={tab}>
                          <li
                            className={
                              selectedTab === tab
                                ? "tab-item selected"
                                : "tab-item"
                            }
                          >
                            <button
                              className={`tab-button ${
                                selectedTab === tab ? "active" : ""
                              }`}
                              onClick={(e) => handleTabChange(e, tab)}
                            >
                              {tab}
                            </button>
                          </li>
                          {selectedTab === tab && (
                            <img
                              src={ButtonTriangle}
                              alt="tri"
                              className="tab-triangle"
                            />
                          )}
                        </div>
                      ))}
                    </ul>

                    <div className="tab-content">
                      {selectedTab === "Vendor Name" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Vendor Name</label>
                            <Controller
                              name="vendorName"
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Vendor Name"
                                  className="dateInput"
                                  maxLength={20}
                                  pattern="[A-Za-z0-9 ]+"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    const cleanedVal = e.target.value.replace(
                                      /[^a-zA-Z0-9 ]/g,
                                      ""
                                    );
                                    field.onChange(cleanedVal);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      vendorName: cleanedVal,
                                    }));
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Vendor Id" && (
                        <div className="dateField">
                          <div className="dateInputWrapper">
                            <label className="dateLabel">Vendor Id</label>
                            <Controller
                              name="vendorId"
                              control={control}
                              render={({ field }) => (
                                <input
                                  {...field}
                                  type="text"
                                  placeholder="Enter Vendor Id"
                                  className="dateInput"
                                  maxLength={20}
                                  pattern="[A-Za-z0-9]+"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    const cleanedVal = e.target.value.replace(
                                      /[^a-zA-Z0-9]/g,
                                      ""
                                    );
                                    field.onChange(cleanedVal);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      vendorId: cleanedVal,
                                    }));
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Transaction Type" && (
                        <div className="dateField">
                          <label className="dateLabel">Transaction Type</label>
                          <div className="dateInputWrapper">
                            <Controller
                              name="txnsType"
                              control={control}
                              render={({ field }) => (
                                <select
                                  {...field}
                                  className="dateInput"
                                  value={field.value || ""}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      txnsType: e.target.value,
                                    }));
                                  }}
                                >
                                  <option value="" disabled>
                                    Select Transaction Type
                                  </option>
                                  {serviceType.map((opt) => (
                                    <option key={opt.value} value={opt.value}>
                                      {opt.label}
                                    </option>
                                  ))}
                                </select>
                              )}
                            />
                          </div>
                        </div>
                      )}

                      {selectedTab === "Status" && (
                        <div className="dateField">
                          <label
                            className="dateLabel"
                            style={{
                              marginBottom: "0.5rem",
                              fontWeight: "600",
                              fontSize: "25px",
                            }}
                          >
                            Status
                          </label>
                          <div
                            className="dateInputWrapper"
                            style={{
                              display: "flex",
                              gap: "1rem",
                              flexWrap: "wrap",
                              padding: "0.75rem",
                              backgroundColor: "#f8f9fa",
                              border: "1px solid #ced4da",
                              borderRadius: "0.5rem",
                            }}
                          >
                            {[
                              { label: "Success", value: "C" },
                              { label: "Failed", value: "F" },
                            ].map((status) => (
                              <label
                                key={status.value}
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "0.5rem",
                                  padding: "0.5rem 0.75rem",
                                  borderRadius: "0.375rem",
                                  cursor: "pointer",
                                  fontSize: "0.9rem",
                                  fontWeight: "500",
                                  boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
                                }}
                              >
                                <input
                                  type="checkbox"
                                  checked={(filterData.status || []).includes(
                                    status.value
                                  )}
                                  onChange={(e) => {
                                    const isChecked = e.target.checked;
                                    const newStatus = isChecked
                                      ? [
                                          ...(filterData.status || []),
                                          status.value,
                                        ]
                                      : (filterData.status || []).filter(
                                          (v) => v !== status.value
                                        );
                                    setValue("status", newStatus);
                                    setFilterData((prev) => ({
                                      ...prev,
                                      status: newStatus,
                                    }));
                                  }}
                                  style={{ cursor: "pointer" }}
                                />
                                {status.label}
                              </label>
                            ))}
                          </div>
                        </div>
                      )}

                      {selectedTab === "Transaction Date" && (
                        <div
                          className="dateGrid"
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: "1rem",
                            alignItems: "flex-start",
                          }}
                        >
                          <Controller
                            name="fromDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid From Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "From Date cannot be in the future",
                                beforeToDate: (value, formValues) =>
                                  !value ||
                                  !formValues.toDate ||
                                  new Date(value) <=
                                    new Date(formValues.toDate) ||
                                  "From Date must be before To Date",
                                requiredIfToDate: (value, formValues) =>
                                  !formValues.toDate ||
                                  !!value ||
                                  "From Date is required when To Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">From Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        fromDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.fromDate && (
                                    <div className="error-text">
                                      {errors.fromDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                          <Controller
                            name="toDate"
                            control={control}
                            rules={{
                              validate: {
                                validDate: (value) =>
                                  !value ||
                                  !isNaN(Date.parse(value)) ||
                                  "Invalid To Date",
                                notFuture: (value) =>
                                  !value ||
                                  new Date(value) <= new Date() ||
                                  "To Date cannot be in the future",
                                afterFromDate: (value, formValues) =>
                                  !value ||
                                  !formValues.fromDate ||
                                  new Date(value) >=
                                    new Date(formValues.fromDate) ||
                                  "To Date must be after From Date",
                                requiredIfFromDate: (value, formValues) =>
                                  !formValues.fromDate ||
                                  !!value ||
                                  "To Date is required when From Date is selected",
                              },
                            }}
                            render={({ field }) => (
                              <div className="dateField" style={{ flex: 1 }}>
                                <label className="dateLabel">To Date</label>
                                <div className="dateInputWrapper">
                                  <input
                                    {...field}
                                    type="date"
                                    className="dateInput"
                                    max={getTodayDate()}
                                    onChange={(e) => {
                                      field.onChange(e);
                                      setFilterData((prev) => ({
                                        ...prev,
                                        toDate: e.target.value,
                                      }));
                                    }}
                                  />
                                  {errors.toDate && (
                                    <div className="error-text">
                                      {errors.toDate.message}
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>

                <div
                  className="scoped-modal"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    padding: "12px",
                    paddingBottom: "0px",
                    gap: "16px",
                    borderTop: "1px solid #dee2e6",
                  }}
                >
                  <div className="buttonContainer">
                    <button
                      type="button"
                      className="btn btn-back w-[133px] !rounded-lg"
                      onClick={onReset}
                    >
                      Reset
                    </button>
                  </div>
                  <div className="buttonContainer">
                    <button
                      type="submit"
                      className="btn btn-submit w-[133px] !rounded-lg"
                      disabled={isSubmitting}
                    >
                      {loading ? (
                        <CircularProgress
                          style={{ width: "20px", height: "20px" }}
                        />
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </div>
              </Box>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default VendorHistoryFilterModal;
